import http from './request'

// 查询悬浮标剩余时间
export const getSuspensionTimeLeft = (data) => {
  return http({
    url: '/promotion/ActivityTaskRecord/getSuspensionTimeLeft',
    method: 'post',
    data
  })
}

// 获取邀请记录
export const getInviteRecordPageList = (data) => {
  return http({
    url: '/promotion/ActivityUserBind/getInviteRecordPageList',
    method: 'post',
    data
  })
}

// 点击paly to win
export const getAppLink = (data) => {
  return http({
    url: '/advertCenter/AdjustLink/getAppLink',
    method: 'post',
    data
  })
}

// 新增参与活动用户
export const createLotteryUser = (data) => {
  return http({
    url: '/promotion/LotteryUser/create',
    method: 'post',
    data
  })
}

// 获取用户信息
export const getBoxUserData = (data) => {
  return http({
    url: '/promotion/LotteryUser/getInfo',
    method: 'post',
    data
  })
}

// 弹幕数据
export const getBarrageList = (data) => {
  return http({
    url: '/promotion/VirtualLotteryRecord/getList',
    method: 'post',
    data
  })
}

// 奖品列表
export const getLotteryList = (data) => {
  return http({
    url: '/promotion/LotteryPlan/getList',
    method: 'post',
    data
  })
}

// 抽奖
export const doLottery = (data) => {
  return http({
    url: '/promotion/Lottery/CrownBox/doLottery',
    method: 'post',
    data
  })
}

// 新增用户盲盒数量
export const addLotteryChance = (data) => {
  return http({
    url: '/promotion/LotteryChanceRecord/create',
    method: 'post',
    data
  })
}

// 获取活动详情接口
export const getBoxActivityInfo = (data) => {
  return http({
    url: '/promotion/Activity/getInfo',
    method: 'post',
    data
  })
}

// 获取用户抽奖提现门槛
export const boxWithdrawGetThresholdList = (data) => {
  return http({
    url: '/promotion/LotteryWithdraw/getThresholdList',
    method: 'post',
    data
  })
}

// 用户提现
export const boxActivityWithdraw = (data) => {
  return http({
    url: '/promotion/LotteryWithdraw/withdraw',
    method: 'post',
    data
  })
}

// 获取抽奖提现记录
export const boxWithdrawGetRecordPagedList = (data) => {
  return http({
    url: '/promotion/LotteryWithdraw/getRecordPagedList',
    method: 'post',
    data
  })
}

// 获取分享模板
export const shareTpl = (id) => {
  return http({
    url: `/promotion/auth/appShareConfig/template/${id}/detail`,
    method: 'post'
  })
}
